import { combineReducers } from 'redux'

import {
  approvalsReducer as approvals,
  currentApprovalReducer as currentApproval,
  productCategoryFilter as category,
  approvalCountReducer as approvalCount,
} from 'containers/Approval/ApprovalPage/reducer'
import {
  commentsReducer as comments
} from 'containers/Approval/CommentSection/reducer'
import {
  approverHistoryReducer as approverHistories,
  workflowHistoryReducer as workflowHistories,
} from 'containers/Approval/HistorySection/reducer'
import {
  approverImageReducer as approverImages,
  workflowApproverReducer as approvers,
  workflowApproverApprovalReducer as approverApprovals,
} from 'containers/Approval/ApproverSection/reducer'
import approvalDialog from 'containers/Approval/ApprovalDialog/reducer'
import {scheduleReducer as schedule} from 'containers/Approval/ScheduleSection/reducer' 

const approvalUiReducer = combineReducers({
  category,
})

export default combineReducers({
  currentApproval,
  approvals,
  comments,
  approverHistories,
  workflowHistories,
  approverImages,
  approvers,
  approverApprovals,
  approvalCount,
  approvalDialog,
  schedule
})

export {
  approvalUiReducer
}
